"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dateToolbox = require("./date/dateToolbox");
var _multiCheckboxToolbox = require("./multiCheckbox/multiCheckboxToolbox");
var _singleRadioToolbox = require("./singleRadio/singleRadioToolbox");
var _headerToolbox = require("./header/headerToolbox");
var _phoneToolbox = require("./phone/phoneToolbox");
var _emailToolbox = require("./email/emailToolbox");
var _numberToolbox = require("./number/numberToolbox");
var _dropdownToolbox = require("./dropdown/dropdownToolbox");
var ToolBoxCustom = {
  DateToolbox: _dateToolbox.DateToolbox,
  MultiCheckboxToolbox: _multiCheckboxToolbox.MultiCheckboxToolbox,
  SingleRadioToolbox: _singleRadioToolbox.SingleRadioToolbox,
  HeaderToolbox: _headerToolbox.HeaderToolbox,
  PhoneToolbox: _phoneToolbox.PhoneToolbox,
  EmailToolbox: _emailToolbox.EmailToolbox,
  NumberToolbox: _numberToolbox.NumberToolbox,
  DropdownToolbox: _dropdownToolbox.DropdownToolbox,
  defineDateCSS: _dateToolbox.defineDateCSS,
  defineHeaderCSS: _headerToolbox.defineHeaderCSS,
  definePhoneCSS: _phoneToolbox.definePhoneCSS,
  defineEmailCSS: _emailToolbox.defineEmailCSS,
  defineNumberCSS: _numberToolbox.defineNumberCSS,
  defineMultiCheckboxCSS: _multiCheckboxToolbox.defineMultiCheckboxCSS,
  defineRadioGroupCSS: _singleRadioToolbox.defineRadioGroupCSS,
  defineDropdownCSS: _dropdownToolbox.defineDropdownCSS
};
var _default = ToolBoxCustom;
exports.default = _default;